/// <reference path="../../_references.ts"/>

module App.History {
	import AppRootScope = App.Administrative.AppRootScope;
	import BannerService = App.WorkOrder.BannerService;
	import OfficeService = App.Utils.OfficeService;
	import Package = App.PriceGuide.Package;
	import ReturnedProduct = App.PriceGuide.ReturnedProduct;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import TitleBarService = App.Helpers.TitleBarService;
	import ToastService = App.Utils.ToastService;
	import WorkOrderService = App.WorkOrder.WorkOrderService;
	import AdministrativeService = App.Administrative.AdministrativeService;
	import AppointmentChecklist = App.Administrative.AppointmentChecklist;
	import CustomerService = App.Customer.CustomerService;

	export class RecommendationsDetailController {

		static $inject: string[] = [
			'$rootScope', '$state', 'TitleBarService', 'AdministrativeService', 'BannerService', 'HistoryService',
			'SelectedAppointment', '$stateParams', 'OfficeService', '$sce', 'WorkOrderService', 'ToastService', '$window',
			'CustomerService', 'OrganizationService',
		];

		selectedHistoricalServiceRequest: App.Customer.ServiceRequest;

		recommendations: Package[];
		inEditMode: boolean = false;
		fromOffice: boolean = false;
		usesServicePlans: boolean = false;

		email: string = null;
		emailNote: string = '';
		edittedEmail: string = '';
		editEmailFlyout: boolean = false;
		showNewEmail: boolean = false;
		newEmail: string = '';
		emailRecommendation: boolean[];
		sending: boolean = false;
		appointmentChecklist: AppointmentChecklist = null;
		isDeleting?: number = null;
		isLoadingDeleted: boolean = false;
		isDeletedOpen: boolean = false;
		deletedPackages: Package[];
		customer: App.Customer.ICustomer = null;

		sortableOptions: Object = {
			containment: '.packages',
			scrollableContainer: '.work-order-body',
			allowDuplicates: false
		};

		ssp_price_card_text: string = '□□□□ □□□□□□□□□ □□□□□□□□□□□';

		constructor(
			private $rootScope: AppRootScope,
			private $state: ng.ui.IStateService,
			private TitleBarService: TitleBarService,
			protected AdministrativeService: AdministrativeService,
			private BannerService: BannerService,
			private HistoryService: HistoryService,
			private SelectedAppointment: SelectedAppointment,
			private $stateParams: ng.ui.IStateParamsService,
			private OfficeService: OfficeService,
			private $sce: ng.ISCEService,
			private WorkOrderService: WorkOrderService,
			protected ToastService: ToastService,
			private $window: Window,
			private CustomerService: CustomerService,
			private OrganizationService: App.Utils.OrganizationService
		) {
			TitleBarService.set('History');

			$rootScope.app.startAppLoading();

			OfficeService.getAppointment().then(() => {
				this.fromOffice = true;
				this.initialize();
			})
			.catch(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					this.initialize();
				});
			});

			OrganizationService.getPriceCardText()
				.then((r) => this.ssp_price_card_text = r.data.ssp_price_card_text);
		}

		initialize() {
			const vm = this;

			if(vm.$stateParams.id) {
				vm.HistoryService.getServiceRequest(vm.$stateParams.id)
					.then((response) => {
						this.customer = (<App.Customer.ICustomer>response.data.customer);

						var emails = this.customer.emails,
							email = emails.find(function(email) {
								return email.marketing;
							});

						vm.selectedHistoricalServiceRequest = response.data;

						email = email || emails.pop();
						vm.email = email ? email.email : null;

						if(vm.selectedHistoricalServiceRequest) {
							vm.getRecommendations(vm.selectedHistoricalServiceRequest.id);
						} else {
							vm.$rootScope.app.stopAppLoading();
						}
					});
				vm.AdministrativeService.GetAppointmentChecklist(vm.SelectedAppointment.id).then((response) => {
					vm.appointmentChecklist = response.data;
				});
			} else {
				vm.$rootScope.app.stopAppLoading();
				vm.$state.go('zipSolutions.history.recommendations');
			}

			return vm.WorkOrderService.getServicePlans(vm.SelectedAppointment.id).then(response => {
				if (response.data.length > 0) {
					vm.usesServicePlans = true;
				}
			});
		}

		toggleDeletedPackages() {
			if (this.deletedPackages) {
				this.isDeletedOpen = !this.isDeletedOpen;
				return;
			}

			if (this.isLoadingDeleted) {
				return;
			}

			this.isLoadingDeleted = true;

			this.HistoryService.getRecommendationsByServiceRequest(this.$stateParams.id, { archived: 1 })
				.then((response) => {
					this.deletedPackages = response.data;
					this.isDeletedOpen = true;
				})
				.catch((err) => {
					this.ToastService.showError('Unable to load deleted recommendations: ', err);
				})
				.finally(() => {
					this.isLoadingDeleted = false;
				});
		}

		restorePackage(pkg: Package) {
			if (this.isDeleting !== null) {
				return;
			}

			this.isDeleting = pkg.id;

			this.HistoryService.restoreRecommendation(pkg.id)
				.then((response) => {
					this.deletedPackages.splice(this.deletedPackages.findIndex((cPkg) => cPkg.id === pkg.id), 1);
					this.recommendations.push(response.data);
				})
				.catch((err) => {
					this.ToastService.showError('Unable to restore recommendation: ', err);
				})
				.finally(() => {
					this.isDeleting = null;
				});
		}

		deletePackage(pkg: Package, index: number) {
			if (this.isDeleting !== null) {
				return;
			}

			this.isDeleting = pkg.id;

			this.HistoryService.deleteRecommendation(pkg.id)
				.then((response) => {
					this.emailRecommendation[index] = false;
					if (this.deletedPackages) {
						this.deletedPackages.push(response.data);
					}
					this.recommendations.splice(this.recommendations.findIndex((cPkg) => cPkg.id === pkg.id), 1);
				})
				.catch((err) => {
					this.ToastService.showError('Unable to delete recommendation: ', err);
				})
				.finally(() => {
					this.isDeleting = null;
				});
		}

		goBack() {
			if (!this.fromOffice) {
				this.$window.history.back();
			} else {
				this.$state.go(this.$state.current, this.$stateParams, { reload: true });
			}
		}

		getRecommendations(invoiceId: number) {
			const vm = this;

			vm.HistoryService.getRecommendationsByServiceRequest(invoiceId).then((response) => {
				vm.recommendations = response.data;
				vm.emailRecommendation = new Array(vm.recommendations.length).fill(true);
				vm.$rootScope.app.stopAppLoading();
			});
		}

		convertToWorkOrder(recommendation: Package) {
			const vm = this;

			if(recommendation) {
				vm.$rootScope.app.startAppLoading();
				vm.HistoryService.convertRecommendationToWorkOrder(vm.SelectedAppointment.service_request, recommendation.id).then((response) => {
					vm.getRecommendations(vm.selectedHistoricalServiceRequest.id);
					vm.$rootScope.app.stopAppLoading();
				});
			}
		}

		isItemized(pkg: Package) {
			return pkg.mode === 'itemized';
		}

		getItemizedPrice(packageProduct: ReturnedProduct, pkg: Package): string {
			return '$' + (
				this.showMultiPrice(pkg)
					? packageProduct.service.while_here_with_out_agreement
					: packageProduct.service.while_here_with_agreement
			);
		}

		secureIframeSrc(videoId: string) {
			return this.$sce.trustAsResourceUrl(`https://www.youtube.com/embed/${videoId}?autoplay=1`);
		}

		showMultiPrice(pkg: Package): boolean {
			return this.usesServicePlans && !!pkg.can_show_regular_pricing && this.getRegularPricing(pkg) !== this.getMaintenancePricing(pkg);
		}

		getSSPCardText(): string {
			return this.ssp_price_card_text;
		}

		isWhileHere(pkg: Package): boolean {
			return pkg.mode === 'whilehere';
		}

		canBeFinanced(pkg: Package): boolean {
			return this.getMaintenanceMonthlyPrice(pkg) != null && this.customer.can_show_financing;
		}

		getRegularPricing(pkg: Package): string {
			let price = '$';

			switch(pkg.mode) {
				case 'admin':
					price = 'Admin';
					break;
				case 'regular':
				case 'whilehere':
					price += pkg.prices[pkg.mode].regular;
					break;
				case 'itemized':
					price += pkg.prices[pkg.mode].whilehere;
					break;
				default:
					price += pkg.prices.regular.regular;
					break;
			}

			return price;
		}

		getMaintenancePricing(pkg: Package): string {
			let price = '$';

			switch(pkg.mode) {
				case 'admin':
					price = 'Admin';
					break;
				case 'regular':
				case 'whilehere':
					price += pkg.prices[pkg.mode].service;
					break;
				case 'itemized':
					if (this.usesServicePlans || !this.showMultiPrice(pkg)) {
						price += pkg.prices.itemized.service;
					} else {
						price += pkg.prices.itemized.whilehere;
					}
					break;
				default:
					price += pkg.prices.regular.service;
					break;
			}

			return price;
		}

		getMaintenanceMonthlyPrice(pkg: Package): string {
			switch(pkg.mode) {
				case 'admin':
					return null;
				case 'regular':
				case 'whilehere':
				case 'itemized':
					return pkg.prices[pkg.mode].servicemonthly;
				default:
					return pkg.prices.regular.servicemonthly;
			}
		}

		getMaintenanceMonthlyPricing(pkg: Package): string {
			let price = this.getMaintenanceMonthlyPrice(pkg);

			if(price == null){
				return null;
			}
			return `${price} / month *`;
		}

		editEmail() {
			this.email = this.edittedEmail;
			this.editEmailFlyout = false;

			if (this.showNewEmail) {
				this.CustomerService.createEmail(this.customer.id, this.newEmail).then((email) => {
					this.customer.emails.push(email.data);
					this.email = this.edittedEmail = email.data.email;
					this.newEmail = '';
					this.showNewEmail = false;
					this.ToastService.show('Email created');
				});
			}
		}

		getSelectedRecommendations() {
			return this.recommendations.filter((r) => {
				return this.emailRecommendation[r.id];
			});
		}

		showPackageNote(pkg: Package): boolean {
			return pkg.description !== null;
		}

		canShowProducts(): boolean {
			return true;
		}

		emailRecommendations() {
			const vm = this;

			vm.sending = true;
			vm.HistoryService.emailRecommendations(
				vm.selectedHistoricalServiceRequest.id,
				this.getSelectedRecommendations()
					.map(r => {
						return r.id;
					}),
				vm.email,
				this.emailNote
			).then(() => {
				vm.appointmentChecklist.email_recommendations = true;
				vm.AdministrativeService.UpdateAppointmentChecklist(vm.SelectedAppointment.id, vm.appointmentChecklist).then(()=> {
					vm.sending = false;
					vm.ToastService.show("Email sent.");
					vm.goBack();
				}).catch((err) => {
					this.ToastService.showError('Unable to send email: ', err);
					vm.sending = false;
				});
			}).catch((err) => {
				this.ToastService.showError('Unable to send email: ', err);
				vm.sending = false;
			});
		}
	}
}
